let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b0Aes")).then(() => parcelRequire('eKycu'));